const app = {
  default: {
    locale: 'en'
  },
  hiddenHeaderPaths: [
    '/business',
    '/business/',
    '/business/register',
    '/business/forgot-password',
    '/business/unverified',
    '/business/rejected'
  ],
  hiddenHeaderPathRegex: [
    '^/business/reset-password/[^/]+$',
    '^/banner/[^/]+$',
    '^/product/[^/]+$'
  ]
}

const BASE_PATH_API = '/api/business'
const BASE_PUBLIC_PATH_API = '/api/business/public'

const api = {
  auth: {
    logout: (origin) => `/business/auth/logout?location=business&service=${origin}/business`
  },
  performance: {
    chartData: {
      find: `${BASE_PATH_API}/performance`
    },
    orderItem: {
      find: `${BASE_PATH_API}/order-item`,
      export: `${BASE_PATH_API}/order-item/export`
    }
  },
  commission: {
    transaction: {
      find: `${BASE_PATH_API}/transaction`
    },
    statement: {
      export: `${BASE_PATH_API}/transaction/export`
    }
  },
  wallet: {
    getWallet: `${BASE_PATH_API}/wallet`
  },
  generateLink: {
    generate: `${BASE_PATH_API}/generate-link`,
    generateMerchantLink: `${BASE_PATH_API}/generate-merchant-link`
  },
  register: {
    submit: `${BASE_PUBLIC_PATH_API}/member`
  },
  countries: {
    find: '/api/masterDataRegion/country'
  },
  forgotPassword: {
    submit: `${BASE_PUBLIC_PATH_API}/reset-password/send`
  },
  resetPassword: {
    submit: (token) => `${BASE_PUBLIC_PATH_API}/reset-password/${token}`
  },
  verifyToken: {
    verify: (token) => `${BASE_PUBLIC_PATH_API}/reset-password/${token}`
  },
  settlement: {
    find: `${BASE_PATH_API}/settlement`,
    invoice: {
      upload: transactionId => `${BASE_PATH_API}/settlement/${transactionId}/invoice`,
      download: transactionId => `${BASE_PATH_API}/settlement/${transactionId}/invoice`
    },
    status: {
      get: `${BASE_PATH_API}/kyc/status`
    }
  },
  member: {
    company: {
      find: `${BASE_PATH_API}/member/company`
    },
    bankInformation: {
      find: `${BASE_PATH_API}/member/bank-information`
    },
    profile: {
      get: `${BASE_PATH_API}/user`
    }
  },
  config: {
    contentAffiliate: `${BASE_PUBLIC_PATH_API}/config/business-affiliate-config/value`
  },
  changePassword: {
    submit: `${BASE_PATH_API}/user/change-password`
  },
  contract: {
    commissionRule: {
      find: `${BASE_PATH_API}/contract/commission`
    },
    commissionExclusion: {
      find: `${BASE_PATH_API}/contract/commission-exclusion`
    }
  },
  sellerCampaign: {
    find: `${BASE_PATH_API}/seller-campaign`,
    categoryFilter: `${BASE_PATH_API}/seller-campaign/category-filter`
  },
  topSellingCategories: {
    find: `${BASE_PATH_API}/top-selling-categories`
  },
  customBanner: {
    find: `${BASE_PATH_API}/custom-banner`
  },
  banner: {
    generate: `${BASE_PATH_API}/banner`,
    category: {
      find: (id) => `${BASE_PUBLIC_PATH_API}/banner/category/${id}`
    },
    product: {
      find: (id) => `${BASE_PUBLIC_PATH_API}/banner/product/${id}`
    }
  }
}

const pages = {
  home: {
    path: '/business/',
    name: 'home'
  },
  unverified: {
    path: '/business/unverified',
    name: 'unverified'
  },
  rejected: {
    path: '/business/rejected',
    name: 'rejected'
  },
  register: {
    path: '/business/register',
    name: 'register'
  },
  forgotPassword: {
    path: '/business/forgot-password',
    name: 'forgot-password'
  },
  resetPassword: {
    path: '/business/reset-password/:token',
    name: 'reset-password'
  },
  performance: {
    path: '/business/performance',
    name: 'performance',
    value: 0
  },
  bonusCommission: {
    path: '/business/bonus-commission',
    name: 'bonusCommission',
    value: 1
  },
  commission: {
    path: '/business/commission',
    name: 'commission',
    value: 3
  },
  generateLink: {
    path: '/business/generate-link',
    name: 'generateLink',
    value: 2
  },
  banner: {
    path: '/business/banner',
    name: 'banner',
    value: 5
  },
  profile: {
    path: '/business/settings/profile',
    name: 'profile'
  },
  changePassword: {
    path: '/business/settings/change-password',
    name: 'changePassword'
  },
  bankInformation: {
    path: '/business/settings/bank-information',
    name: 'bankInformation'
  },
  contract: {
    path: '/business/contract',
    name: 'contract',
    value: 4
  },
  categoryBannerRender: {
    path: '/banner/:id',
    name: 'category-banner-render'
  },
  productBannerRender: {
    path: '/product/:id',
    name: 'product-banner-render'
  }
}

const FILTER_TYPE = {
  LAST_7_DAYS: 'LAST_7_DAYS',
  LAST_30_DAYS: 'LAST_30_DAYS',
  LAST_3_MONTHS: 'LAST_3_MONTHS',
  CUSTOM_RANGE: 'CUSTOM_RANGE'
}

const BUYER_STATUS = {
  NEW_BUYER: 'true',
  EXISTING_BUYER: 'false'
}

const COMMISSION_STATUS = {
  COMPLETE: 'COMPLETE',
  PROCESSED: 'PROCESSED',
  NOT_VALID: 'NOT_VALID'
}

const COMMISSION_TAB = {
  EARNING: 'EARNING',
  WITHDRAWAL: 'WITHDRAWAL'
}

const COMPANY_TYPE = [
  'AFFILIATE_NETWORK',
  'LOYALTY_AND_REWARDS_PLATFORM',
  'PERFORMANCE_MARKETING_AGENCIES',
  'COUPON_AND_CASHBACK_SITES',
  'EMAIL_AND_NEWSLETTER_PLATFORM',
  'REVIEW_AND_COMPARISON_WEBSITES',
  'TECHNOLOGY_SOLUTIONS',
  'AFFILIATE_MARKETPLACES'
]

const REGISTER_ERROR = {
  USER_ALREADY_EXISTS: 'USER_ALREADY_EXISTS',
  MEMBER_ALREADY_EXISTS_BY_USERNAME: 'MEMBER_ALREADY_EXISTS_BY_USERNAME',
  COMPANY_NAME_ALREADY_EXISTS: 'COMPANY_NAME_ALREADY_EXISTS',
  MEMBER_ALREADY_EXISTS_BY_PHONE_NUMBER: 'MEMBER_ALREADY_EXISTS_BY_PHONE_NUMBER',
  PHONE_NUMBER_ALREADY_EXISTS: 'PHONE_NUMBER_ALREADY_EXISTS',
  MEMBER_ALREADY_EXISTS_BY_EMAIL: 'MEMBER_ALREADY_EXISTS_BY_EMAIL'
}

const INVOICE_STATUS = {
  SUCCESS: {
    key: 'SUCCESS',
    color: 'green'
  },
  IN_PROGRESS: {
    key: 'IN_PROGRESS',
    color: 'blue'
  },
  PENDING: {
    key: 'PENDING',
    color: 'yellow'
  },
  REJECTED: {
    key: 'REJECTED',
    color: 'red'
  },
  EXPIRED: {
    key: 'EXPIRED',
    color: 'gray'
  }
}

const SETTLEMENT_BANNER = {
  BANK_ACCOUNT_UNVERIFIED: {
    status: 'alert'
  },
  INVOICE_STATUS_PENDING: {
    status: 'alert'
  },
  INVOICE_STATUS_REJECTED: {
    status: 'error'
  },
  INVOICE_STATUS_EXPIRED: {
    status: 'general'
  },
  INVOICE_STATUS_SUCCESS: {
    status: 'success'
  }
}

const BANK_ACCOUNT_STATUS = {
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
  UNVERIFIED: 'UNVERIFIED',
  DELETED: 'DELETED',
  IN_PROCESS: 'IN_PROCESS'
}

const PRODUCT_BANNER_TYPE = {
  SQUARE: 'square',
  LONG: 'long',
  WIDE: 'wide',
  TOWER: 'tower'
}

const PRODUCT_BANNER_LAYOUT = {
  '250x250': { type: PRODUCT_BANNER_TYPE.SQUARE, perView: 1, carousel: true, scale: 1 },
  '300x250': { type: PRODUCT_BANNER_TYPE.SQUARE, perView: 1, carousel: true, scale: 1 },
  '728x90': { type: PRODUCT_BANNER_TYPE.LONG, perView: 3, carousel: false, scale: 2 },
  '360x90': { type: PRODUCT_BANNER_TYPE.WIDE, perView: 1, carousel: true, scale: 2 },
  '120x600': { type: PRODUCT_BANNER_TYPE.TOWER, perView: 2, carousel: true, scale: 2 }
}

const REGISTER_REVIEW_DAY = 7
const constant = {
  FILTER_TYPE,
  DEFAULT_RANGE: FILTER_TYPE.LAST_7_DAYS,
  DEFAULT_METRICS: 'commission',
  BUYER_STATUS,
  COMMISSION_STATUS,
  COMMISSION_TAB,
  EMAIL_FORMAT_PATTERN: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
  PASSWORD_FORMAT_PATTERN: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/,
  PHONE_NUMBER_FORMAT_PATTERN: /^\+62\d{8,15}$/,
  COMPANY_TYPE,
  TNC_VERSION: '1742377773',
  REGISTER_ERROR,
  REGISTER_REVIEW_DAY,
  PASSWORD_HIDDEN_TYPE: 'password',
  PASSWORD_SHOWN_TYPE: 'text',
  STORE_ID: '10001',
  CHANNEL_ID: 'web',
  CLIENT_ID: 'affiliate',
  REQUEST_ID: 'business-affiliate-ui',
  INVOICE_STATUS,
  SETTLEMENT_BANNER,
  BANK_ACCOUNT_STATUS,
  UNVERIFIED_STATUS: 'USER_VERIFICATION_PENDING',
  PRODUCT_BANNER_TYPE,
  PRODUCT_BANNER_LAYOUT,
  PRODUCT_BANNER_DEFAULT_RATIO: '250x250'
}

export { api, app, constant, pages }
